// grammarLawService.js
import axios from 'axios';

const opensearchEndpoint = process.env.VUE_APP_OPENSEARCH_URL;
const DEFAULT_SIZE = 40000

// TODO replace this with production index
const indexName = localStorage.getItem('grammarIndex');;

export const grammerLawService = {
  getGrammerLaws,
};


async function getGrammerLaws() {
  let laws = [];
  let updated;

  // Encode the credentials in Base64
  const credentials = Buffer.from(`admin:${process.env.VUE_APP_OPENSEARCH_PASSWORD}`).toString('base64');
  const authHeader = `Basic ${credentials}`;

  try {
    const apiUrl = `${opensearchEndpoint}/_cluster/health`;

    // const response = await axios.get(`${opensearchEndpoint}/_cluster/health`, { params });

    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': authHeader,
        'Content-Type': 'application/json', // Adjust the content type based on your API requirements
      },
      withCredentials: false,
    })

    const domainStatus = response.data;

    if (domainStatus) {
      updated = domainStatus.timestamp; // Adjust based on your OpenSearch data structure
    }
  } catch (error) {
    console.error('Error retrieving OpenSearch index information:', error);
    return laws;
  }

  const CACHE_KEY = 'grammarCacheEng';
  const DATA_KEY = 'grammarEng';

  // Check if the data is already in local storage and is up-to-date
  if (window.localStorage.getItem(CACHE_KEY)) {
    if (window.localStorage.getItem(CACHE_KEY) === updated) {
        if (window.localStorage[DATA_KEY]) {
          laws = JSON.parse(window.localStorage[DATA_KEY]);
        return laws;
      }
    }
  }

  // Retrieve data from OpenSearch index
  const query = {
    size: DEFAULT_SIZE,
    query: {
      match_all: {}, // Adjust the query as needed
    },
  };

  try {
    const apiUrl = `${opensearchEndpoint}/${indexName}/_search`;

    const response = await axios.post(apiUrl, query, 
    {
      headers: {
        'Authorization': authHeader,
        'Content-Type': 'application/json', // Adjust the content type based on your API requirements
      },
      withCredentials: false,
    }
  );
    laws = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
  } catch (error) {
    console.error('Error retrieving data from OpenSearch:', error.response ? error.response.data : error.message);
    return laws;
  }

  // Cache data in local storage
  window.localStorage.setItem('grammarEng', JSON.stringify(laws));
  window.localStorage.setItem('grammarCacheEng', updated);

  return laws;
}



// WEBPACK FOOTER //
// ./src/services/grammerLawService.js